import React, {Component} from 'react';

import {PageHead} from 'components/header/components';

import DocumentsAll from '../documents/documents';

class MainPage extends Component {
  render() {
    return (
      <div>
        <PageHead>

        </PageHead>
        <DocumentsAll/>
      </div>
    )
  }
}

export default MainPage;



// WEBPACK FOOTER //
// ./src/admin/main/index.js